var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadge3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 72.9677C57.7599 72.9677 72.9677 57.7599 72.9677 39C72.9677 20.2401 57.7599 5.03226 39 5.03226C20.2401 5.03226 5.03226 20.2401 5.03226 39C5.03226 57.7599 20.2401 72.9677 39 72.9677ZM39 78C60.5391 78 78 60.5391 78 39C78 17.4609 60.5391 0 39 0C17.4609 0 0 17.4609 0 39C0 60.5391 17.4609 78 39 78Z",
    fill: "#C5DEB1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4432 36.9628C46.8715 35.8073 48.3376 33.6295 48.3376 31.0517C48.3834 26.2073 44.5348 23.1406 39.266 23.1406C35.6007 23.1406 32.4394 24.7851 30.5151 27.274L33.6764 30.4295C34.8218 28.874 36.8835 27.8962 38.8078 27.8962C41.2361 27.8962 42.8855 29.2295 42.9771 31.2295C43.0687 33.4962 41.0986 35.2295 37.8915 35.2295H35.784V39.274H38.762C42.0149 39.274 44.3516 41.1851 44.3516 43.9406C44.3516 46.5184 42.0608 48.4295 38.7162 48.4295C36.3796 48.4295 34.4095 47.1406 33.035 44.9628L29.1406 47.674C31.1565 51.1851 34.6386 53.1406 38.9453 53.1406C45.2679 53.1406 49.7121 49.4517 49.7121 44.1184C49.7121 40.6962 47.6503 38.0295 44.4432 36.9628Z",
    fill: "#C5DEB1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge3);
export default __webpack_public_path__ + "static/media/badge3.c13d36ad1985ed324f572dd5cac10cb9.svg";
export { ForwardRef as ReactComponent };